/* ENISSATI · PDP Main — vanilla JS
   - Galeria: thumbnail click → muda imagem ativa
   - ATC: AJAX POST /cart/add.js + dispara eventos pixel
     - Klaviyo (_learnq), Meta (fbq), Google Analytics (gtag), TikTok (ttq)
     - CustomEvent 'cart:item-added' pra outros apps detectarem
*/
(function () {
  'use strict';

  /* Notifica o tema Krunkers após mudança no carrinho (contrato real do theme.js):
     eventos em document.documentElement com detail.cart completo.
     - 'cart:updated' → CartCount atualiza o número do badge
     - 'cart:refresh' → CartDrawer re-renderiza (busca o próprio HTML se faltar sections)
     Eventos em `document` sem detail.cart NÃO funcionam (rootDelegate escuta no documentElement). */
  function notifyCartUpdated() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true, detail: { cart: cart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: {
            cart: cart,
            openMiniCart: !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'drawer')
          }
        }));
      })
      .catch(function () { /* silencioso: badge atualiza no próximo pageload */ });
  }

  function init(section) {
    var productData = window.ENISSATI_PDP && window.ENISSATI_PDP['product_' + section.dataset.productId];
    if (!productData) return;

    // ─── Galeria — thumbnail click + setas prev/next + dots mobile ───
    var thumbs = section.querySelectorAll('[data-thumb]');
    var mediaItems = section.querySelectorAll('[data-media-index]');
    var navButtons = section.querySelectorAll('[data-nav]');
    var dots = section.querySelectorAll('[data-dot-index]');

    function setActive(idx) {
      idx = Math.max(0, Math.min(mediaItems.length - 1, idx));
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumbIndex) === String(idx)); });
      mediaItems.forEach(function (m) { m.classList.toggle('is-active', String(m.dataset.mediaIndex) === String(idx)); });
      dots.forEach(function (d) { d.classList.toggle('is-active', String(d.dataset.dotIndex) === String(idx)); });
    }
    function currentIndex() {
      for (var i = 0; i < mediaItems.length; i++) {
        if (mediaItems[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setActive(parseInt(thumb.dataset.thumbIndex, 10));
      });
    });

    navButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.dataset.nav === 'prev' ? -1 : 1;
        var next = currentIndex() + dir;
        // wrap-around
        if (next < 0) next = mediaItems.length - 1;
        if (next >= mediaItems.length) next = 0;
        setActive(next);
      });
    });

    // ─── Swipe horizontal (mobile/touch + mouse drag) ───
    var mediaWrap = section.querySelector('.ss-pm__media');
    if (mediaWrap && mediaItems.length > 1) {
      var startX = 0, startY = 0, deltaX = 0, deltaY = 0;
      var isDragging = false, isDecided = false, isHorizontal = false;
      var pointerId = null;
      var THRESHOLD = 30;
      var DIR_RATIO = 1.2;

      function getActiveItem() {
        for (var i = 0; i < mediaItems.length; i++) {
          if (mediaItems[i].classList.contains('is-active')) return mediaItems[i];
        }
        return null;
      }

      function onPointerDown(e) {
        // swipe SÓ no touch (mobile) — no desktop o mouse usa setas/thumbnails (clique);
        // capturar o ponteiro no mouse engolia o clique das setas. Por isso só 'touch'.
        if (e.pointerType !== 'touch') return;
        startX = e.clientX;
        startY = e.clientY;
        deltaX = 0;
        deltaY = 0;
        isDragging = true;
        isDecided = false;
        isHorizontal = false;
        pointerId = e.pointerId;
        // captura o ponteiro pra continuar recebendo eventos mesmo fora do elemento
        try { mediaWrap.setPointerCapture(e.pointerId); } catch (err) {}
      }

      function onPointerMove(e) {
        if (!isDragging || e.pointerId !== pointerId) return;
        deltaX = e.clientX - startX;
        deltaY = e.clientY - startY;

        // decide direção uma vez por gesto (uma vez que deltas são significativos)
        if (!isDecided && (Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8)) {
          isHorizontal = Math.abs(deltaX) > Math.abs(deltaY) * DIR_RATIO;
          isDecided = true;
        }

        if (isHorizontal) {
          if (e.cancelable) e.preventDefault();
          // Feedback visual: arrasta a imagem ativa junto com o dedo (resistência leve)
          var active = getActiveItem();
          if (active) {
            active.style.transform = 'translateX(' + (deltaX * 0.6) + 'px)';
            active.style.transition = 'none';
          }
        }
      }

      function onPointerUp(e) {
        if (!isDragging || (e && e.pointerId !== pointerId)) return;
        isDragging = false;
        try { mediaWrap.releasePointerCapture(pointerId); } catch (err) {}

        var active = getActiveItem();
        if (active) {
          active.style.transition = 'transform 0.22s ease';
          active.style.transform = '';
          // remove transition depois do snap-back
          setTimeout(function () {
            if (active) active.style.transition = '';
          }, 240);
        }

        if (isHorizontal && Math.abs(deltaX) > THRESHOLD) {
          var dir = deltaX < 0 ? 1 : -1;
          var next = currentIndex() + dir;
          if (next < 0) next = mediaItems.length - 1;
          if (next >= mediaItems.length) next = 0;
          setActive(next);
        }
      }

      // PointerEvents cobre touch, mouse e pen num único API moderno
      mediaWrap.addEventListener('pointerdown', onPointerDown);
      mediaWrap.addEventListener('pointermove', onPointerMove);
      mediaWrap.addEventListener('pointerup', onPointerUp);
      mediaWrap.addEventListener('pointercancel', onPointerUp);
      mediaWrap.addEventListener('pointerleave', onPointerUp);
    }

    // ─── ATC — AJAX cart + eventos ───
    var atcButton = section.querySelector('[data-atc]');
    if (atcButton) {
      atcButton.addEventListener('click', function (e) {
        e.preventDefault();
        var variantId = atcButton.dataset.variantId;
        if (!variantId) return;

        var originalText = atcButton.innerHTML;
        atcButton.disabled = true;
        atcButton.innerHTML = '<span class="ss-pm__atc-text">…</span>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }]
          })
        })
          .then(function (r) {
            // 422 (esgotado/limite de estoque) vem como JSON válido — sem este check
            // caía no caminho de sucesso com "✓ AJOUTÉ" falso + pixels falsos.
            if (!r.ok) {
              return r.json().then(function (err) {
                throw new Error(err.description || err.message || 'Erreur panier');
              });
            }
            return r.json();
          })
          .then(function (data) {
            // Feedback visual: check verde
            atcButton.innerHTML = '<span class="ss-pm__atc-text">✓ AJOUTÉ</span>';
            atcButton.classList.add('is-added');

            // Atualiza badge do carrinho + drawer (contrato Krunkers)
            notifyCartUpdated();

            // ─── Pixels ───
            try {
              // Klaviyo
              if (window._learnq) {
                window._learnq.push(['track', 'Added to Cart', {
                  $value: productData.price / 100,
                  AddedItemProductName: productData.title,
                  AddedItemProductID: String(productData.id),
                  AddedItemSKU: productData.variant_id,
                  AddedItemCategories: [productData.type].filter(Boolean),
                  AddedItemImageURL: productData.image,
                  AddedItemURL: productData.url,
                  AddedItemPrice: productData.price / 100,
                  AddedItemQuantity: 1
                }]);
              }
              // Meta Pixel
              if (window.fbq) {
                window.fbq('track', 'AddToCart', {
                  content_ids: [String(productData.id)],
                  content_name: productData.title,
                  content_type: 'product',
                  currency: productData.currency,
                  value: productData.price / 100
                });
              }
              // Google Analytics 4
              if (window.gtag) {
                window.gtag('event', 'add_to_cart', {
                  currency: productData.currency,
                  value: productData.price / 100,
                  items: [{
                    item_id: String(productData.id),
                    item_name: productData.title,
                    item_brand: productData.vendor,
                    item_category: productData.type,
                    price: productData.price / 100,
                    quantity: 1
                  }]
                });
              }
              // TikTok Pixel
              if (window.ttq) {
                window.ttq.track('AddToCart', {
                  content_id: String(productData.id),
                  content_type: 'product',
                  content_name: productData.title,
                  currency: productData.currency,
                  value: productData.price / 100,
                  quantity: 1
                });
              }
            } catch (err) {
              console.warn('[PDP] pixel events:', err);
            }

            // Reset visual após 2.4s
            setTimeout(function () {
              atcButton.disabled = false;
              atcButton.innerHTML = originalText;
              atcButton.classList.remove('is-added');
            }, 2400);
          })
          .catch(function (err) {
            console.error('[PDP] add to cart error', err);
            atcButton.innerHTML = '<span class="ss-pm__atc-text">ERREUR — RÉESSAYER</span>';
            atcButton.classList.add('is-error');
            setTimeout(function () {
              atcButton.disabled = false;
              atcButton.innerHTML = originalText;
              atcButton.classList.remove('is-error');
            }, 2400);
          });
      });
    }
  }

  /* ─── Buy now — ACHETER MAINTENANT ───
     JS: adiciona via /cart/add.js (preserva o carrinho) e vai direto pro /checkout.
     Se o fetch falhar, segue o href (cart permalink /cart/VARIANT:1 — substitui o
     carrinho, mas garante a compra). Sem JS nenhum, o href já funciona sozinho. */
  function initBuyNow(section) {
    var buyNow = section.querySelector('[data-buy-now]');
    if (!buyNow) return;
    buyNow.addEventListener('click', function (e) {
      e.preventDefault();
      if (buyNow.classList.contains('is-loading')) return; // anti duplo-clique
      var variantId = buyNow.dataset.variantId;
      if (!variantId) { window.location.href = buyNow.getAttribute('href'); return; }
      buyNow.classList.add('is-loading');
      buyNow.style.opacity = '0.6';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          // fallback: cart permalink do próprio href
          window.location.href = buyNow.getAttribute('href');
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pdp-main]').forEach(function (s) {
      init(s);
      initBuyNow(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init em Shopify editor
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector) {
      ev.target.querySelectorAll('[data-pdp-main]').forEach(function (s) {
        init(s);
        initBuyNow(s);
      });
    }
  });
})();

/* ============================================================
   Koala gift card — PIN no buy box da PDP
   O app Koala usa UM elemento <koala-gifts-reward-showcase> e o
   joga no mini-cart drawer (oculto) em vez do buy box, então o
   card "Inclus avec l'achat" pisca e some. Este pin devolve o
   card pro .ss-pm__info (logo após os botões de compra) e o
   re-fixa se o Koala tentar movê-lo. Não toca no app Koala.
   ============================================================ */
(function () {
  'use strict';
  var info = document.querySelector('.ss-pm__info');
  if (!info) return; // só em PDP com nosso buy box

  function pinKoalaGift() {
    var card = document.querySelector('koala-gifts-reward-showcase');
    if (!card) return;
    var anchor = info.querySelector('.ss-pm__actions') || info.querySelector('form[is="product-form"]');
    if (!anchor || !anchor.parentElement) return;
    // posição final = logo após os botões de compra. Move só se ainda não estiver lá
    // (cobre tanto o caso "mini-cart" quanto um flash acima dos botões).
    if (card.previousElementSibling !== anchor) {
      anchor.parentElement.insertBefore(card, anchor.nextSibling);
    }
    // revela só depois de posicionado (CSS mantém opacity:0 até esta classe → sem flash)
    card.classList.add('ss-koala-ready');
  }

  // 1) Poll nos primeiros ~12s (cobre a injeção tardia do Koala)
  var tries = 0;
  var iv = setInterval(function () {
    pinKoalaGift();
    if (++tries > 48) clearInterval(iv);
  }, 250);

  // 2) Observer: re-fixa se o Koala (re)injetar/mover o card depois
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.tagName === 'KOALA-GIFTS-REWARD-SHOWCASE' ||
            (n.querySelector && n.querySelector('koala-gifts-reward-showcase')))) {
          pinKoalaGift();
          return;
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
